export default __webpack_public_path__ + "static/hero-7ad98029dc37e1c78eec8c67043f94b8.webp";